import React, { Component } from 'react'
import { Cart, Group, Toast, Pos } from "@shopify/app-bridge/actions";
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { Context } from '@shopify/app-bridge-react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
const queryString = require('query-string')

const messages = defineMessages({
    "valid_user": {
        id: 'invoice.pos.payment',
        defaultMessage: 'Please add a valid customer to your cart before trying to apply a payment.',
    },
    "valid_cart": {
        id: 'invoice.pos.new_invoice',
        defaultMessage: 'Please add an item to your cart before you proceed.',
    },
    "warning": {
        id: 'invoice.pos.warning',
        defaultMessage: 'Warning!',
    },
})

class ContactValidationComponent extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            error: null,
            shopifyCustomer: null,
            contact: null,
            loading: true,
            cartInfo: null,
            checkCart: this.props.checkCart || false,
        }
        ContactValidationComponent.contextType = Context;
        this.setCartData = this.setCartData.bind(this);
        this.verifyCart = this.verifyCart.bind(this);
        this.isValid = this.isValid.bind(this);
        this.displayErrorMessage = this.displayErrorMessage.bind(this);
    }

    componentDidMount() {
        this.verifyCart()
    }

    verifyCart() {
        const shopifyApp = this.context;
        const cart = Cart.create(shopifyApp);
        const pos= Pos.create(shopifyApp)
        const unsubscriber = cart.subscribe(Cart.Action.UPDATE, payload => {
            unsubscriber();
            this.setCartData(payload.data);
        });
     
        shopifyApp.featuresAvailable([Group.Cart]).then(function (state) { 
            var Dispatch = state && state.Cart && state.Cart["FETCH"] && state.Cart["FETCH"].Dispatch
            var DispatchOthers= state && state.Cart && state.Cart[Cart.Action.FETCH] && state.Cart[Cart.Action.FETCH].Dispatch
            if (Dispatch || DispatchOthers) {
                cart.dispatch(Cart.Action.FETCH);
            } else {
                var toastOptions = {
                    message: 'Cart is not available',
                    duration: 5000,
                    isError: true
                };
                var toastError = Toast.create(shopifyApp, toastOptions);
                toastError.dispatch(Toast.Action.SHOW);
                pos.dispatch(Pos.Action.CLOSE);
            }
        });
    }

    isValid(shopifyCustomer) {
        let postData = {
            keywords: '*',
            objects: ['contacts'],
            fields: [
                'identifier',
            ],
            totals: [],
            filters: {
                "{oneOf}": {
                    "uniqueExternalId": "shopify_" + shopifyCustomer.id,
                }
            },
            pageSize: 10,
            activePage: 1,
            sortAsc: false,
            sortByField: "identifier",
            lightResult: true,
        }
        AppContext.getApiClient().post('/listing/search', postData).then(res => {
            if (!res.error) {
                this.setState({
                    contact: res.data[0],
                    shopifyCustomer: shopifyCustomer,
                    loading: false
                })
            } else {
                this.setState({
                    contact: {},
                    shopifyCustomer: {},
                    error: res.error,
                    loading: false
                })
            }
        })
    }

    setCartData(data) {
        if (this.props.checkCart) {
            const { lineItems } = data
            if (lineItems.length > 0) {
                this.setState({
                    cartInfo: data
                })
            }
        }
        if (data && data.customer) {
            this.isValid(data.customer)
        } else {
            this.setState({
                loading: false
            })
        }
    }

    displayErrorMessage() {
        const contactErrorMessage = this.state.shopifyCustomer && this.state.contact && this.state.contact.id ? "" : this.props.intl.formatMessage(messages["valid_user"]);
        if (this.props.checkCart) {
            return this.state.cartInfo ? contactErrorMessage : this.props.intl.formatMessage(messages["valid_cart"]);
        } else {
            return contactErrorMessage
        }
    }

    render() {
        let cartValidation = (this.state.checkCart && this.state.cartInfo) || !this.state.checkCart
        let childrenWithProps = React.Children.map(this.props.children,
            child => React.cloneElement(child, {
                shopifyCustomer: this.state.shopifyCustomer,
                contact: this.state.contact,
                cartInfo: this.state.cartInfo
            }))

        return this.state.shopifyCustomer && this.state.contact && this.state.contact.id && cartValidation ?
            childrenWithProps[0] :
            this.state.loading ?
                <div className="text-center">
                    <LoadingSpinner marginTop="20px" />
                    <FormattedMessage
                        id="signin.external.loading"
                        defaultMessage="Signing in to QuoteMachine..."
                    />
                </div> :
                <div className="alert alert-warning alert-dismissible fade show">
                    <h4 className="alert-heading"><i className="fa fa-warning"></i> {this.props.intl.formatMessage(messages["warning"])}</h4>
                    {this.state.error && this.state.error.type == "auth_error" ?
                        <div>
                            <p>
                                "{this.state.error.message}"
                            </p>
                            <FormattedMessage
                                id="signin.external.please_contact_support"
                                defaultMessage="Please Contact Support at contact@quotemachine.com"
                            />
                        </div> :
                        <div>{this.displayErrorMessage()}</div>
                    }
                </div>
    }

}

export default injectIntl(ContactValidationComponent);



// WEBPACK FOOTER //
// ./src/embed/shopify/contactvalidation.component.jsx